export interface ICallbackTask {
    partitionKey: string;

    sortKey: string;

    taskStatus: string;

    callbackAction: string;

    callbackPayload?: { [key: string]: unknown };

    taskResult?: { [key: string]: unknown };

    handledBy?: string;
}
